export enum ActionableCardViewState {
    ShowCard = 1,
    HideCard,
    HideCardWithError,
    ActionInProgress,
    ShowActionsResponse,
}
